// Encode a string to Base64
export const encodeBase64 = (str) => {
  try {
    return window.btoa(unescape(encodeURIComponent(str)));
  } catch (error) {
    console.error("Base64 encoding failed:", error);
    return null;
  }
};

// Decode a Base64 string
export const decodeBase64 = (base64Str) => {
  try {
    return decodeURIComponent(escape(window.atob(base64Str)));
  } catch (error) {
    console.error("Base64 decoding failed:", error);
    return null;
  }
};
